import { render } from "./branch-choose.vue?vue&type=template&id=9c965a5e"
import script from "./branch-choose.vue?vue&type=script&lang=js"
export * from "./branch-choose.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__